export default {
  sm: `
    데이터센터 각 세종은
    네이버가 가진 모든 첨단기술과 
    서비스의 동력이자 미래 기술의 
    실체입니다.
  `,
  md: `
    데이터센터 각 세종은
    네이버가 가진 모든 첨단기술과 서비스의
    동력이자 미래 기술의 실체입니다.
  `,
};
